export const translations = {
    en: {
      Overview:"Overview",
      overallSummary: "Overall Summary",
      tons: "TONS",
      cumulativeExport: "Cumulative export volume from all mines.",
      viewDetail: "View detail",
      incidentRisks: "Incident Risks",
      legitimacy: "Legitimacy",
      humanWorkersRights: "Human & Workers Rights",
      societalWelfareSecurity: "Societal Welfare/Security",
      companyGovernance: "Company Governance",
      chainOfCustodyTraceability: "Chain of Custody/Traceability",
      environment: "Environment",
      communityImpact: "Community Impact",
      EventsOverview:"Events Overview",
      load:" The events overview might take some time to load...",
      Incidents:"Incidents", 
      Exports:"Exports",
      Assessments:"Assessments",
      Production:"Production",
      Blending:"Blending",
      Processing:"Processing",
      Purchase:"Purchase"
      // Add more translations as needed
    },
    fr: {
      Overview:"Vue d'ensemble",
      overallSummary: "Résumé Général",
      tons: "TONNES",
      cumulativeExport: "Volume d'exportation cumulé de toutes les mines.",
      viewDetail: "Voir les détails",
      incidentRisks: "Risques d'incidents",
      legitimacy: "Légitimité",
      humanWorkersRights: "Droits humains et des travailleurs",
      societalWelfareSecurity: "Bien-être sociétal/Sécurité",
      companyGovernance: "Gouvernance de l'entreprise",
      chainOfCustodyTraceability: "Chaîne de traçabilité",
      environment: "Environnement",
      communityImpact: "Impact communautaire",
      EventsOverview:"Carte de synthèse des événements",
      load:"Le chargement de l'aperçu des événements peut prendre un certain temps…",
      Incidents:"Incidents",
      Exports:"Exportations",
      Assessments:"Évaluations",
      Production:"Production",
      Blending:"Mélange",
      Processing:"Traitement",
      Purchase:"achat"


      // Add more translations as needed
    }
  };